import React from "react";
import "../index.css";

const Loading = () => {
  return (
    <div className="loadingio-spinner-gear-hchart9hme">
      <div className="ldio-k4ygfxzqhp">
        <div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default Loading;
